/* eslint-disable indent */
import bridge from "@vkontakte/vk-bridge"
import axios from "axios"
import { createEffect, createEvent, createStore, sample } from "effector"
import { ICurrentWinnerPanel, INomination, INominationVotes, VK_SHARE_TITLE, VK_SHARE_URL } from "src/shared/config"

// ВТОРОЙ ЭТАП
// Получаем номинации второго этапа
const getNominationsFx = createEffect<void, void, Error>(async () => {
  try {
    const { data } = await axios("/nominations_2022.json")
    return data
  } catch (error) {
    throw new Error("Ошибка получения номинаций")
  }
})

// Стор с номинациями второго этапа
export const $nominations = createStore<INomination[]>([]).on(getNominationsFx.doneData, (_, nominations) => nominations)

// Стор текущей панели голосования
export const setCurrentNomination = createEvent<ICurrentWinnerPanel>()
export const $currentNomination = createStore<ICurrentWinnerPanel>("anim_hero").on(setCurrentNomination, (_, currentNomination) => currentNomination)

// Эффект отправки голосов второго этапа
export const postSecondStageVotesFx = createEffect(
  () => {}
  // async (votes: INominationVotes) => {
  //   try {
  //     await axios.post(`${BASE_URL}${SEND_SEC_STAGE_VOICES_EP}`, votes);
  //     openFinalPanel();
  //   } catch (error) {
  //     setGetOrPostError(true);
  //   }
  // }
)

// Стор для голосов второй стадии + ивенты к нему
export const postSecondStageVotesClock = createEvent()
export const setSecondStageVotes = createEvent<INominationVotes>()
export const $chooseSecondStageVotes = createStore<INominationVotes>({}).on(setSecondStageVotes, (store, vote) => ({ ...store, ...vote }))

// Если заполнено хоть одно поле - отправляем голоса
sample({
  clock: postSecondStageVotesClock,
  source: $chooseSecondStageVotes,
  filter: ($chooseSecondStageVotes) => !!Object.keys($chooseSecondStageVotes).length,
  target: postSecondStageVotesFx,
})

// // ЯНДЕКС МЕТРИКА
// // Отправляем цели при переходах на страницы
// const sendYMGoalsFx = createEffect(async (currentPanel: ActivePanelT) => {
//   switch (currentPanel) {
//     case ActivePanelsVariants.RULES: {
//       window.ym(92342167, 'reachGoal', 'open-rules');
//       break;
//     }
//     case ActivePanelsVariants.VOITING: {
//       window.ym(92342167, 'reachGoal', 'open-voting');
//       break;
//     }
//     case ActivePanelsVariants.FINAL: {
//       window.ym(92342167, 'reachGoal', 'send-votes-success');
//       break;
//     }
//     default:
//       break;
//   }
// });

// Шарим пост в вк находясь в вк и отслеживаем это событие
export const shareToVkInVkFx = createEffect(() => {
  bridge.send("VKWebAppShowWallPostBox", {
    message: VK_SHARE_TITLE,
    attachments: VK_SHARE_URL,
  })
  // @ts-ignore
  bridge.send("VKWebAppSendCustomEvent", {
    event: "share_post_click",
  })
  window.ym(92342167, "reachGoal", "share-in-vk")
})

// Шарим пост в вк, находясь на стороннем сайте
export const shareToVkStandaloneFx = createEffect(() => {
  window.ym(92342167, "reachGoal", "share-to-vk-standalone")
})
